import { render, staticRenderFns } from "./ListSeguroiformapagtoPage.vue?vue&type=template&id=4a0e3ae9"
import script from "./ListSeguroiformapagtoPage.vue?vue&type=script&lang=js"
export * from "./ListSeguroiformapagtoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports